import { Controller, Toolbar } from '@tencent/workbench';
import { OCRPictureFeature } from './ocr-picture-feature';
import { TOOLBAR_ITEMS, config } from './config';
import { wrapIdForVip } from '@src/framework/workbench/util/wrap-id-util';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
})
export class OCRPictureController {
    public constructor(private readonly feature: OCRPictureFeature) {
    }

    @Toolbar(wrapIdForVip(config.id), 'onClick')
    public onClick() {
        this.feature.showOcrRightBar();
    }

    @Toolbar(wrapIdForVip(config.id), 'shouldDisabled')
    public shouldOCRDisabled(): boolean {
        return this.feature.shouldOCRDisabled();
    }
}
